// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Masthead[data-v-06f4e1a2]{z-index:2}.Masthead__image.is-parallax>img[data-v-06f4e1a2]{-o-object-position:center;object-position:center;font-family:\"object-fit: cover; object-position: center\"}.parallax-overlay[data-v-06f4e1a2]{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1}.contain[data-v-06f4e1a2]{-o-object-fit:contain!important;object-fit:contain!important}", ""]);
// Exports
module.exports = exports;
